import React, { useEffect, useState, useContext } from "react";
import Rating from "@material-ui/lab/Rating";
import { Box, Grid } from "@mui/material";
import School from "@mui/icons-material/School";
import Typography from "@mui/material/Typography";
import { obtenerReviews } from "../Services/reviewsServices";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import Container from "@mui/material/Container";
import { fechaBase } from "../Script/script";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const Review = ({ idUdemy, titulo }) => {
  const [reviews, setReviews] = useState([]);
  const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

  useEffect(() => {
    window.scrollTo(0, 0);
    //console.log(idUdemy);
    cargarReviews();
    //cargarAlumnos();
    //setRatings(rating.results.filter((r) => r.content !== ""));
  }, [idUdemy]);

  const cargarReviews = async () => {
    const { data: reviews } = await obtenerReviews(idUdemy);
    let rev = reviews.results.filter((r) => r.content !== "" && r.rating >= 4);
    setReviews(rev);

    /*rev.map((a) =>
      setAlumnos([...alumnos, { alumno: a.user.display_name, curso: titulo }])
    );*/

    //console.log(alumnos);
  };
  /*let al;
  const cargarAlumnos = async () => {
    al = reviews.map((a) => ({
      alumno: a.user.display_name,
      titulo: titulo,
    }));

    console.log(al);
  };*/

  return (
    <Container disableGutters>
      <Box>
        <AutoPlaySwipeableViews
          interval={5000}
          enableMouseEvents
          style={{ cursor: "pointer" }}
        >
          {reviews.map((rate, index) => (
            <Grid container spacing={2}>
              <Grid item>
                <ArrowBackIosIcon />
              </Grid>
              <Grid item>
                <Box key={index}>
                  <Rating
                    name="size-small"
                    defaultValue={rate.rating}
                    precision={0.5}
                    readOnly
                    size="large"
                  />

                  <Typography
                    variant="h6"
                    color="textSecondary"
                    component="legend"
                  >
                    <School sx={{ fontSize: 20 }} />
                    &nbsp;
                    <b>{rate.user.display_name}</b>
                    <br />
                    <i>{rate.content.substring(0, 300) + "..."}</i>
                    <br />
                    <i>{fechaBase(rate.modified, "DD/MM/YYYY")}</i>
                  </Typography>
                </Box>
              </Grid>
              <Grid item>
                <ArrowForwardIosIcon />
              </Grid>
            </Grid>
          ))}
        </AutoPlaySwipeableViews>
      </Box>
    </Container>
  );
};

export default Review;
